import nsToken from '@netsapiens/netsapiens-js/dist/token';
import { select } from 'redux-saga/effects';

// eslint-disable-next-line import/prefer-default-export
export function* setFavicon() {
  const { apiURL, hostname } = yield select((state) => state.configs);
  let domain = '*';
  let territory = '*';
  let decodedToken = null;
  if (nsToken) decodedToken = nsToken.getDecoded();

  if (decodedToken && decodedToken.domain) domain = decodedToken.domain;
  if (decodedToken && decodedToken.territory) territory = decodedToken.territory;

  if (!apiURL || !domain || !hostname) {
    console.error('setFavicon service missing param');
    return Promise.resolve(false);
  }

  let faviconURL = `${apiURL}?object=image&action=read&server=${hostname}&filename=favicon.gif`;

  if (domain && domain !== '*') { faviconURL += `&domain=${domain}`; }
  if (territory && territory !== '*') { faviconURL += `&territory=${territory}`; }

  const link = document.querySelector('link[rel*="icon"]') || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = faviconURL;
  document.getElementsByTagName('head')[0].appendChild(link);

  return Promise.resolve(true);
}
